export enum PremiumPackageActions {
  scheduleContent = 0,
  approveSubscribers = 1,
  identityVerification = 2,
  autoWithdraw = 3,
  access4k = 4,
}
